import { Grid } from '@material-ui/core'
import useStyles from './styles'
import { FC } from 'react'
import { TextFieldLabel } from 'components/UI'
import { EstimateContact } from 'ducks/types'
import {
  PHONE_MASK_INPUT,
  validateEmail,
  validatePhone,
} from 'helpers/index'
import { useStepperContext } from 'hooks/useStepperContext'

export interface ContactProps {
  contact?: Partial<EstimateContact>
  onChange?: (key: keyof EstimateContact, val: string | number) => void
  style?: any
  error?: string
}

const RequiredLabel: FC<{ hasError: boolean; children: string }> = ({
  hasError,
  children,
}) => (
  <>
    <span style={{ color: hasError ? 'red' : undefined }}>*</span> {children}
  </>
)

const Contact: FC<ContactProps> = ({ contact, onChange, style, error }) => {
  const classes = useStyles()

  const { showWarnings } = useStepperContext()

  return (
    <>
      <Grid item className={classes.contact} style={style}>
        <Grid container item spacing={2}>
          <Grid item xs={12} lg={6}>
            <TextFieldLabel
              label={<RequiredLabel hasError={!!(showWarnings && !contact?.firstName)}>First Name</RequiredLabel>}
              value={contact?.firstName || ''}
              error={showWarnings && !contact?.firstName}
              helperText={
                showWarnings && !contact?.firstName
                  ? 'First name is required'
                  : ''
              }
              onChange={(event: any) =>
                onChange && onChange('firstName', event.target.value)
              }
              placeholder="Homeowner Name"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextFieldLabel
              label={<RequiredLabel hasError={!!(showWarnings && !contact?.lastName)}>Last Name</RequiredLabel>}
              value={contact?.lastName || ''}
              error={showWarnings && !contact?.lastName}
              helperText={
                showWarnings && !contact?.lastName
                  ? 'Last name is required'
                  : ''
              }
              onChange={(event: any) =>
                onChange && onChange('lastName', event.target.value)
              }
              placeholder="Homeowner Last Name"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextFieldLabel
              label={<RequiredLabel hasError={!!(showWarnings && !validatePhone(contact?.phone || ''))}>Phone</RequiredLabel>}
              value={contact?.phone || ''}
              onChange={(event: any) =>
                onChange && onChange('phone', event.target.value)
              }
              placeholder="555-555-1234"
              mask={PHONE_MASK_INPUT}
              type="tel"
              error={showWarnings && !validatePhone(contact?.phone || '')}
              helperText={
                showWarnings && !contact?.phone?.trim()
                  ? 'Phone is required'
                  : showWarnings &&
                    contact?.phone &&
                    !validatePhone(contact?.phone || '')
                  ? 'Enter a valid phone number'
                  : ''
              }
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextFieldLabel
              label={<RequiredLabel hasError={!!(showWarnings && (!contact?.email || !validateEmail(contact?.email)))}>Email</RequiredLabel>}
              value={contact?.email || ''}
              error={
                showWarnings &&
                (!contact?.email || !validateEmail(contact?.email))
              }
              helperText={
                showWarnings && !contact?.email?.trim()
                  ? 'Email is required'
                  : showWarnings &&
                    contact?.email &&
                    !validateEmail(contact?.email)
                  ? 'Enter a valid email address'
                  : ''
              }
              onChange={(event: any) =>
                onChange && onChange('email', event.target.value)
              }
              placeholder="email@mail.com"
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            {error && <span className={classes.error}>{error}</span>}
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default Contact
